module.exports = __webpack_public_path__ + "static/assets/729f8aef73fe5151486419e055042a0c.png";